import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import {
  Header,
  IntroPage,
  ChildInfo,
  GuardianParentPage,
  Review,
} from "../../components";

const KiddiesBankPage = () => {
  const [activeStep, setActiveStep] = useState(1);

  const isValidated = useSelector(
    (state) => state.account.createAccount.isValidated
  );

  const nextComponent = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const prevComponent = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };


  if (!isValidated) {
    return <Navigate to="/openKiddiesAccount" replace={true} />;
  }

  return (
    <div className="hero-anime">
      <div className="navigation-wrap text-suntrust start-header start-style">
        <Header />
      </div>
      <div className="main_content" id="main-content">
        {activeStep === 1 && <IntroPage nextComponent={nextComponent} />}

        {activeStep === 2 && (
          <ChildInfo
            nextComponent={nextComponent}
            prevComponent={prevComponent}
          />
        )}
        {activeStep === 3 && (
          <GuardianParentPage
            nextComponent={nextComponent}
            prevComponent={prevComponent}
          />
        )}

        {activeStep === 4 && (
          <Review nextComponent={nextComponent} prevComponent={prevComponent} />
        )}
      </div>
    </div>
  );
};

export default KiddiesBankPage;
